// extracted by mini-css-extract-plugin
export default {"primeCommunityScrollToTopButton":"PrimeCommunityMobileScrollToTop_primeCommunityScrollToTopButton__0jfvV"};